module.exports = __webpack_public_path__ + "img/galeria-aquario-3.2e274322.jpg";